import { render, staticRenderFns } from "./ChangeToIcon.vue?vue&type=template&id=11b5108d&"
import script from "./ChangeToIcon.vue?vue&type=script&lang=js&"
export * from "./ChangeToIcon.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports